export enum EcommItemPickStrategy {
    PREVIOUSLY_SELECTED = 'previously_selected',
    MOST_RECENT = 'most_recent',
    RANDOM = 'random',
    HIGHEST_PRICE = 'highest_price',
    LOWEST_PRICE = 'lowest_price',
}
